import { data } from '../../svg/PersonAdd/data';
import { makeIcon } from '../makeIcon';

export const PersonAdd = makeIcon(data, 'person_add', 'PersonAdd');

export default PersonAdd;
